
  document.addEventListener("DOMContentLoaded", function () {
     const menuToggle = document.getElementById('menu-toggle');
    const mobileMenu = document.getElementById('mobile-menu');
    const closeBtn = document.getElementById('close-btn');

    if (menuToggle && mobileMenu && closeBtn) {
    menuToggle.addEventListener('click', () => {
    mobileMenu.classList.add('active');
    });

    closeBtn.addEventListener('click', () => {
    mobileMenu.classList.remove('active');
    });
    };
    const faqItems = document.querySelectorAll(".faq-item");

    faqItems.forEach(item => {
      const question = item.querySelector(".faq-question");

      question.addEventListener("click", () => {
        const isOpen = item.classList.contains("active");

        // Close all items
        faqItems.forEach(faq => {
          faq.classList.remove("active");
        });

        // Toggle current item
        if (!isOpen) {
          item.classList.add("active");
        }
      });
    });
  });

  <!-- Cal element-click embed code begins -->
  (function (C, A, L) { let p = function (a, ar) { a.q.push(ar); }; let d = C.document; C.Cal = C.Cal || function () { let cal = C.Cal; let ar = arguments; if (!cal.loaded) { cal.ns = {}; cal.q = cal.q || []; d.head.appendChild(d.createElement("script")).src = A; cal.loaded = true; } if (ar[0] === L) { const api = function () { p(api, arguments); }; const namespace = ar[1]; api.q = api.q || []; if(typeof namespace === "string"){cal.ns[namespace] = cal.ns[namespace] || api;p(cal.ns[namespace], ar);p(cal, ["initNamespace", namespace]);} else p(cal, ar); return;} p(cal, ar); }; })(window, "https://cal.id/embed-link/embed.js", "init");
Cal("init", "default", {origin:"https://cal.id"});
  Cal.ns["default"]("ui", {"cssVarsPerTheme":{"light":{"cal-brand":"#102d10"},"dark":{"cal-brand":"#fafafa"}},"hideEventTypeDetails":false,"layout":"month_view"});
<!-- Cal element-click embed code ends -->

